import { render, staticRenderFns } from "./_base-card.vue?vue&type=template&id=54908c84&scoped=true"
import script from "./_base-card.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-card.vue?vue&type=style&index=0&id=54908c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54908c84",
  null
  
)

export default component.exports